const Wip = () => {
  return(



    <div >

    <div>
    <h4 className="logo"><img src="/images/base/Logo.jpg"alt="" width="40" height="40" className="rounded" />  for a <span className="cRed">better</span> tomorrow </h4>
    <h4 className="cursiveGrayRight">…Eliminating the gap between abundance and need</h4>
    <p >&nbsp;</p>
    </div>

    <div><hr class="hr-line"></hr></div>

    <div>
    <h4 className="center-align"><b >Adminstrator is working on this page. Please try again later.</b></h4>
    <p className="center-align"><img src="/images/base/work-in-progress.png" alt="" width="40%" className="rounded" /></p>
    <div><hr class="hr-line"></hr></div>

    <h4 className="cursiveGray">“Our mission is to promote social justice by meeting needs in the local community and the world through accountable, sustainable philanthropy and by nurturing future generations of servant leaders.”</h4>
    </div>
    </div>


  );
}
export default Wip;
